import React from 'react';
import { Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import validators from '../../../../common/services/validators';

const BankTransferForm = ({ t, franchisor, enabled }) => {
	const isIbanBankTransfer = franchisor.isIbanBankTransfer;
	return (
		<div>
			<Field name='accountHolderName' component={Input} required type='text' label={t('BankTransfer_AccountHolderName')} validate={enabled && validators.required} trimOnBlur />
			<Field name='bankName' component={Input} required type='text' label={t('BankTransfer_BankName')} validate={enabled && validators.required} trimOnBlur />
			{isIbanBankTransfer && <Field name='iban' component={Input} required type='text' label={t('BankTransfer_IBAN')} validate={enabled && validators.required} trimOnBlur />}
			{!isIbanBankTransfer && <Field name='accountNumber' component={Input} required type='text' label={t('BankTransfer_AccountNumber')} validate={enabled && validators.required} trimOnBlur />}
			{!isIbanBankTransfer && <Field name='sortCode' component={Input} required type='text' label={t('BankTransfer_SortCode')} validate={enabled && validators.required} trimOnBlur />}
			<Field name='bic' component={Input} type='text' label={t('BankTransfer_BIC')} trimOnBlur />
			<Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
			<Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
		</div>
	);
};


export default BankTransferForm;